// extracted by mini-css-extract-plugin
export default {"root":"DynamicLogin_root__vruCM","fields":"DynamicLogin_fields__Nh87F","header":"DynamicLogin_header__tbk6p","tip":"DynamicLogin_tip__iDOO8","code":"DynamicLogin_code__rSIOV"};